export default __webpack_public_path__ + "static/10.03-9-1415483aefdad855fc2adc55b40efafd.png";